/* eslint-disable no-case-declarations */
import {
  INIT_AUTH,
  PASSWORD_RESET_ERROR,
  PASSWORD_RESET_SUCCESS,
  PROFILE_UPDATE_SUCCESS,
  PROFILE_UPDATE_FAILURE,
  REGISTER_ERROR,
  REGISTER_SUCCESS,
  SIGN_IN_ERROR,
  SIGN_IN_SUCCESS,
  SIGN_OUT_SUCCESS,
} from './action-types'
import { LOCATION_CHANGE } from 'modules/common'


export const initialState = {
  authenticated: false,
  id: null,
  error: null,
  email: '',
  name: '',
}


export function authReducer(state = initialState, { payload, type }) {
  switch (type) {
    case INIT_AUTH:
      return {
        authenticated: !!payload,
        id: payload ? payload.uid : null,
        email: payload ? payload.email : '',
        name: payload ? payload.displayName : '',
      }

    case SIGN_IN_SUCCESS:
    case REGISTER_SUCCESS:
      return {
        authenticated: true,
        email: payload.email,
        name: payload.displayName || '',
        error: null,
        id: payload.uid,
      }

    case PROFILE_UPDATE_SUCCESS:
      return {
        ...state,
        name: payload.name,
        email: payload.email,
        error: null,
      }

    case PASSWORD_RESET_ERROR:
    case REGISTER_ERROR:
    case SIGN_IN_ERROR:
      return {
        authenticated: false,
        error: payload.message,
      }

    case PROFILE_UPDATE_FAILURE:
      return {
        ...state,
        error: payload.message,
      }

    case SIGN_OUT_SUCCESS:
      return {
        authenticated: false,
        id: null,
        email: null,
        name: null,
      }

    case LOCATION_CHANGE:
    case PASSWORD_RESET_SUCCESS:
      return {
        ...state,
        error: null,
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/modules/auth/reducer.js